import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { RULES } from 'constants/rules';

import BuildBackground from 'components/BuildBackground';
import Button from 'components/Button';
import Input from 'components/Input';
import Typography from 'components/Typography';

import { useLoadingStore } from 'store/useLoadingStore.ts';

import accountImg from 'assets/account_circle.svg';
import lockImg from 'assets/lock.svg';
import logoImg from 'assets/logo.svg';

import {
  AnimatedContent,
  LoginButtons,
  LoginContainer,
  LoginForgotPassword,
  LoginForm,
  LoginTitle,
  Logo,
} from './Login.styled.ts';

type FormData = {
  correo: string;
  contrasena: string;
};

const Login = () => {
  const navigate = useNavigate();

  const [showContent, setShowContent] = useState(false);

  const { loading } = useLoadingStore();

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<FormData>({
    defaultValues: {
      correo: '',
      contrasena: '',
    },
    mode: 'onChange',
  });

  useEffect(() => {
    if (!loading) {
      setTimeout(() => {
        setShowContent(true);
      }, 6000);
    }
  }, [loading]);

  const onSubmit = (data: FormData) => {
    console.log(data);
    navigate('/');
  };

  return (
    <BuildBackground showLogo={!showContent}>
      <AnimatedContent isVisible={showContent}>
        <LoginContainer>
          <Logo src={logoImg} alt="logo" />

          <LoginTitle>
            <Typography type="Title" size="small" style="light" color="#F7F4EE">
              ¡Hola!
            </Typography>
            <Typography type="Body" size="small" style="light" color="#F7F4EE">
              Inicia sesión y gestiona a tus clientes.
            </Typography>
          </LoginTitle>

          <LoginForm>
            <Controller
              name="correo"
              control={control}
              rules={RULES.email}
              render={({ field: { onChange, value } }) => {
                return (
                  <Input
                    title="Usuario"
                    placeholder="Correo electrónico"
                    maxLength={30}
                    theme="dark"
                    icon={accountImg}
                    variant="outlined"
                    inputType="email"
                    value={value}
                    onChange={onChange}
                    isValid={!errors.correo?.message && value.length > 0}
                  />
                );
              }}
            />
            <Controller
              name="contrasena"
              control={control}
              rules={RULES.password}
              render={({ field: { onChange, value } }) => {
                return (
                  <Input
                    title="Contraseña"
                    placeholder="Contraseña"
                    minLength={8}
                    icon={lockImg}
                    theme="dark"
                    type="password"
                    inputType="password"
                    variant="outlined"
                    helperText="Debe tener al menos 8 caracteres. "
                    value={value}
                    onChange={onChange}
                    isValid={!errors.contrasena?.message && value.length > 8}
                  />
                );
              }}
            />

            <LoginForgotPassword>
              <Typography
                type="Link"
                size="medium"
                style="light"
                color="#696863"
              >
                Olvidé mi contraseña
              </Typography>
            </LoginForgotPassword>
          </LoginForm>

          <LoginButtons>
            <Button
              variant="primary"
              onClick={handleSubmit(onSubmit)}
              disabled={!isValid}
            >
              Iniciar sesión
            </Button>
            <Button variant="outlined" disabled>
              Registrarme
            </Button>
          </LoginButtons>
        </LoginContainer>
      </AnimatedContent>
    </BuildBackground>
  );
};

export default Login;
